module.exports = __webpack_public_path__ + "static/media/message-promotion-title@3x.bad83a09.png";